import TemplateView from '../../../../../js/TemplateView'
import {DEFAULT_SORTING} from '../../constants'
import FeedsTableSortingMenu from './FeedsTableSortingMenu'

export default class SharedFeedsTableHeader extends TemplateView {

    constructor({
        changeSorting
    }) {
        super()

        this.state = {
            sorting: DEFAULT_SORTING,
        }

        this.callbacks = {
            changeSorting
        }

        this.onStatePropertyDeeplyChanged('sorting', sorting => this.sortingArea.setState({sorting}))
    }

    templateHtml() {
        return `<div class='header sharedFeeds'>
                    <div class='feedNameColumn'/>
                    <div class='calendarDetailsColumn'>
                        <%=calendarDetailsTitle%>
                    </div>
                    <div class='feedUrlColumn'>
                        <%=feedUrlTitle%>
                    </div>
                </div>`
    }

    messageKeys() {
        return {
            calendarDetailsTitle: 'icalendar.page.table.column.details',
            feedUrlTitle: 'icalendar.page.table.columns.url',
        }
    }

    afterRender() {
        this.sortingArea = new FeedsTableSortingMenu({
            changeSorting: this.callbacks.changeSorting,
        }).init(this.find('.feedNameColumn'))
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/SharedFeedsTableHeader.js